import { EnumBasedItem, createEnumService } from "./base";

export enum PaymentTypeType {
  INVOICE = "invoice",
  STRIPE = "stripe",
  PAYPAL = "paypal",
}

export class PaymentType extends EnumBasedItem<PaymentTypeType> {}

const paymentTypeService = createEnumService(PaymentTypeType, PaymentType);
export default paymentTypeService;

/**
 * Card and PayPal orders are paid up front and only get a receipt; the Swiss QR payment slip
 * exists just for orders that still have to be paid by bank transfer (and bundle refreshes).
 */
export const hasQrBill = (paymentType?: string | null): boolean =>
  paymentType !== PaymentTypeType.STRIPE && paymentType !== PaymentTypeType.PAYPAL;
